/*
 * @Author: Will Keung Lau
 * @Date: 2023-07-02 16:04:11
 * @LastEditors: -.-
 * @LastEditTime: 2025-03-14 10:58:43
 * @Description:  头部注释
 */
import { Empty, Icon, Input, Tooltip } from "antd";
import React, {
  memo,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import Service from "../app.service";
import { iProps } from "./interface";
import "./style.less";

const Api = new Service();

const Matrix: React.FC<iProps> = memo((props) => {
  const { visible, onCancel } = props;
  const contentRef = useRef<HTMLDivElement>(null);
  const [matrixData, setMatrixData] = useState<any[]>([]);
  const [renderMatrixData, setRenderMatrixData] = useState<any[]>([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const timerRef = useRef<any>(null);

  const onInnerCancel = useCallback(
    (e) => {
      e.stopPropagation();
      onCancel?.();
    },
    [onCancel],
  );

  const onTabChange = useCallback((activeKey: string) => {
    const headerHeight =
      contentRef.current.querySelector<HTMLDivElement>(
        `div[data-key="0"]`,
      ).offsetTop;
    const groupTitleDom = contentRef.current.querySelector<HTMLDivElement>(
      `div[data-key="${activeKey}"]`,
    );
    const top = groupTitleDom.offsetTop - headerHeight;
    contentRef.current.scrollTo({
      top,
      behavior: "smooth",
    });
  }, []);

  const getMatrix = useCallback(async () => {
    const data = await Api.getMatrixData();

    const list = data.reduce((pre, cur) => {
      if (!!cur?.categoryList) {
        return [...pre, ...cur?.categoryList];
      }

      return [...pre];
    }, []);

    setMatrixData(list);
    setRenderMatrixData(list);
  }, []);

  useLayoutEffect(() => {
    getMatrix();
  }, [getMatrix]);

  //   useEffect(() => {
  //     emitter.emit("pageUnScroll", visible);
  //   }, [visible]);

  const handFilter = (searchValue) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      let newMatrixData = JSON.parse(JSON.stringify(matrixData));
      let data;

      if (searchValue) {
        data = (newMatrixData ?? []).reduce((pre, cur) => {
          if (!cur?.matrixSystems?.length) return [...pre];

          let newList = [];
          newList = cur?.matrixSystems.filter(
            (item) =>
              item.systemItemName.includes(searchValue) ||
              item?.systemItemPinyin?.includes?.(
                searchValue.toLocaleLowerCase(),
              ),
          );

          if (!!newList?.length) {
            cur.matrixSystems = newList;

            return [...pre, cur];
          } else {
            return [...pre];
          }
        }, []);
      } else {
        data = [...matrixData];
      }

      setRenderMatrixData([...data]);
    }, 800);
  };

  const handleToDetail = async (record: any) => {
    const { functionItemId, functionSplitKey, splitType, actionPath } = record;

    try {
      await Api.saveLog({
        functionId: functionItemId,
        splitKey: functionSplitKey,
        permissionSplitType: splitType,
      });
    } catch (error) {
      console.log("日志记录失败", error);
    }

    window.location.href = actionPath;
  };

  const inputRef = useRef();

  useEffect(() => {
    if (!visible) return;

    setTimeout(() => {
      // @ts-ignore
      inputRef.current?.focus();
    }, 10);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="bx-matrix">
      <Icon className="cancel-icon" type="close" onClick={onInnerCancel} />
      <div className="main-wrapper">
        <div className="header">
          <Input
            className="search"
            ref={inputRef}
            placeholder="请输入关键词"
            prefix={
              <Icon
                type="search"
                style={{
                  marginLeft: 4,
                }}
              />
            }
            onChange={(e) => handFilter(e.target.value)}
          />
        </div>
        <div className="main">
          <div className="right" ref={contentRef}>
            <div className="content">
              {(renderMatrixData ?? []).map((item, index) => (
                <div className="group" key={index}>
                  <div className="title" data-key={index + ""}>
                    {item.groupName}
                  </div>
                  <div className="list">
                    {(item.matrixSystems ?? []).map((it, i) => (
                      <div
                        className="item"
                        key={i}
                        onClick={() => handleToDetail(it)}
                      >
                        <img
                          width={24}
                          height={24}
                          src={it.iconPath}
                          className="img"
                        />
                        <Tooltip title={it.systemItemName}>
                          <div className="text">{it.systemItemName}</div>
                        </Tooltip>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              {!!matrixData?.length && !renderMatrixData?.length && (
                <Empty
                  description="暂无数据"
                  style={{
                    height: 550,
                  }}
                />
              )}
            </div>
          </div>
          <div className="left">
            {(matrixData ?? []).map((item, index) => (
              <div
                className={`tab-item ${
                  activeIndex === index ? "main-tab-item-active" : ""
                }`}
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveIndex(index);
                  onTabChange(index + "");
                }}
              >
                {item.groupName}
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="mask" onClick={onInnerCancel} />
    </div>
  );
});

export default Matrix;
